<template>
    <div>
        <my-form 
        class="form-page" 
        v-model="form" 
        table 
        v-loading="loadingController"
        label-width="180px">
            <el-form-item 
            label="统一项目代码" 
            prop="spxmbh" 
            class="table-full-row"
            :rules="newRule('统一项目代码', 'required')">
                <el-input v-model="form.spxmbh" style="width:70%"></el-input>
                <el-button 
                size="mini" 
                icon="el-icon-search" 
                type="primary" 
                @click="getProInfo"
                style="margin-left:10px">
                    获取统一项目信息
                </el-button>
            </el-form-item>
            
            <el-form-item 
            label="项目名称" 
            prop="proname" 
            :rules="newRule('项目名称', 'required')">
                {{form.proname}}
            </el-form-item>

            <el-form-item 
            label="法人" 
            prop="faren" 
            :rules="newRule('法人', 'required')">
                {{form.faren}}
            </el-form-item>

            <el-form-item 
            label="资金来源" 
            prop="zjly" 
            :rules="newRule('资金来源', 'required')">
                {{form.zjly}}
            </el-form-item>

            <el-form-item 
            label="项目地址" 
            prop="proaddress" 
            :rules="newRule('项目地址', 'required')">
                {{form.proaddress}}
            </el-form-item>

            <el-form-item 
            label="项目规模" 
            prop="xmgm" 
            class="table-full-row"
            :rules="newRule('项目规模', 'required')">
                {{form.xmgm}}
            </el-form-item>

            <template slot="btn">
                <el-button 
                @click="saveHandler()" 
                type="primary" 
                icon="el-icon-circle-check">
                    确定补充
                </el-button>
                <el-button 
                icon="el-icon-circle-close" 
                @click="$emit('cancle')">
                    取消
                </el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
export default {
   
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        
    },
    data: () => ({
        form: {
            spxmbh:''
        },
        loadingController:false,
        flag:false,
        getprocode:''
    }),
    computed: {
       
    },
    methods: {
        // 获取统一项目信息
        getProInfo(){
            if(this.form.spxmbh){
                var that = this
                that.loadingController = true
                that.$post(`${that.getGetters('mngUrl')}/getProInfo/getProInfo.json`,{
                    procode:that.form.spxmbh,
                }, data => {
                    that.loadingController = false;
                    if(data){
                        that.form.proname = data.proname;
                        that.form.faren = data.faren;
                        that.form.zjly = data.zjly;
                        that.form.proaddress = data.proaddress;
                        that.form.xmgm = data.xmgm;
                        that.getprocode = data.procode;
                        that.form.sjly = '1';
                        that.flag = true;
                    }else{
                        ShowMsg('获取统一项目信息出错！','warning');
                    }
                    
                })
            }else{
                ShowMsg('请先输入统一项目代码，拉取信息','warning');
            }
            
        },
        saveHandler(){
            var that = this;
            if(!that.flag){
                ShowMsg('请先拉取统一项目代码信息','warning');
                return;
            }
            if(that.getprocode!=that.form.spxmbh){
                ShowMsg('统一项目代码发生变化，请先拉取统一项目代码信息,再点击保存','warning');
                return;
            }
   
            that.loadingController = true
            that.$post(`${that.getGetters('mngUrl')}/Zbdl/Project/completeProinfo.json`,{
                procode:that.row.procode,
                spxmbh :that.form.spxmbh,
            }, data => {
                that.loadingController = false;
                ShowMsg('统一项目代码补充完成','success');
                that.$emit('cancle')
                that.$emit('reloadpage')
            })
        }
    },
    created() {
        
      
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

/deep/ .form-page{ width: 100%;}
</style>
